/**
 * Feedback + contact API slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const feedbackApi = {
  submit: async (message, turnstileToken) => {
    const data = await fetchWithAuth('/json/feedback', {
      method: 'POST',
      body: { message, 'cf-turnstile-response': turnstileToken }
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to submit feedback', 400, data);
    }

    return data;
  },

  submitMessageFeedback: async (conversationId, messageId, message) => {
    const data = await fetchWithAuth(`/json/conversations/${conversationId}/messages/${messageId}/feedback`, {
      method: 'POST',
      body: { message }
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to submit message feedback', 400, data);
    }

    return data;
  },

  contactSubmit: async ({ email, name, reason, message }) => {
    const data = await fetchWithAuth('/json/contact', {
      method: 'POST',
      body: {
        email: email.trim(),
        name: name.trim(),
        reason,
        message: message.trim()
      }
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to submit contact form', 400, data);
    }

    return data;
  }
};
